<template>
  <div>
    <div class="sub_visual_wrap">
      <div class="sub_visual_box container">
        <div class="page_nav">
          <ul>
            <li>
              <router-link to="/main" @click.native="$store.commit('setActive', '')">{{
                $t("common.home")
              }}</router-link>
            </li>
            <li>
              <a href="#">{{ $t("common.forgot") }}</a>
            </li>
          </ul>
        </div>
        <h2>{{ $t("common.forgot") }}</h2>
      </div>
    </div>

    <section class="sub_contents_wrap">
      <div class="stu_tab">
        <ul class="view_web">
          <li>
            <router-link
              @click.native="[loadComponent('ForgotId'), changeNav('ForgotId')]"
              ref="ForgotId"
              :class="this.$route.path == '/forgot/id' ? 'on' : ''"
              to="/forgot/id"
              >{{ $t("account.findid") }}</router-link
            >
          </li>
          <li>
            <router-link
              @click.native="[loadComponent('ForgotPasswd'), changeNav('ForgotPasswd')]"
              ref="ForgotPasswd"
              :class="this.$route.path == '/forgot/password' ? 'on' : ''"
              to="/forgot/password"
              >{{ $t("account.findpw") }}</router-link
            >
          </li>
        </ul>
        <div class="subtab_drop dropdown">
          <button
            class="btn btn-secondary dropdown-toggle"
            type="button"
            id="subTabdropdown01"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {{ nav }}
          </button>
          <ul class="dropdown-menu" aria-labelledby="subTabdropdown01">
            <li>
              <a
                @click="[loadComponent('ForgotId'), changeNav('ForgotId')]"
                ref="ForgotId"
                :class="this.$route.path == '/forgot/id' ? 'active' : ''"
                class="dropdown-item"
                href="#"
                >아이디 찾기</a
              >
            </li>
            <li>
              <a
                @click="[loadComponent('ForgotPasswd'), changeNav('ForgotPasswd')]"
                ref="ForgotPasswd"
                :class="this.$route.path == '/forgot/password' ? 'active' : ''"
                class="dropdown-item"
                href="#"
                >비밀번호 찾기</a
              >
            </li>
          </ul>
        </div>
      </div>
      <router-view></router-view>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      component: null,
      componentName: null,
      on: false,
      nav: "ForgotId",
    };
  },
  methods: {
    loadComponent(type) {
      this.on = true;
      this.componentName = type;
      this.$store.commit("setComponentName", type);
    },
    changeNav(name) {
      this.nav = name;
    },
  },
  mounted() {
    console.log(this.$route.path);
    if (this.$store.getters.getComponentName != "") {
      this.loadComponent(this.$store.getters.getComponentName);
      this.$store.commit("setComponentName", "");
    } else {
      this.loadComponent("ForgotId");
    }
  },
};
</script>

<style></style>
